export default {
  // 頁面文本
  title: "用戶分享的畫布",
  from: "來自",
  userUid: "用戶uid",
  sharedCanvas: "分享的畫布：",

  // 按鈕
  saveCanvas: "保存畫布",
};
